import { DAY_CLOSING_APIS } from "@/api_framework/api_config";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAPIUtils } from "../../useAPIUtils";

export interface IClinicWalletsActionProps {
  abc: string;
}

AxiosCurlirize(axios, () => {});

export const useDayClosingCurrentShift = () => {
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();
  const [closureData, setClosureData] = useState<any>([]);

  const execute = useCallback(
    async (clinic_id: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: any = await axios
          .get(`${DAY_CLOSING_APIS?.DAY_CLOSING_CURRENT_SHIFT?.baseURL}?clinic_id=${clinic_id}`, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<any>) => {
            if (res.data.status) {
              setClosureData(res.data.data);

              return { status: true };
            } else {
              setClosureData(null);

              //
            }
          })
          .catch((e: AxiosError) => {
            setClosureData(null);
            sendCurl(e.config["curlCommand"]);

            if (e.code === "ERR_BAD_REQUEST") {
              //   toast.error("Error while fetching List details");
            }
            return { status: false };
          });
        return response;
      } catch (e: any) {
        setClosureData(null);
        captureError(e);
      }
    },
    [dispatch],
  );
  return { execute, closureData };
};
